import { inject } from 'mobx-react';
import * as React from 'react';

import { AnalyticsStore } from 'bernie-core';

import { QualtricsStore } from 'stores/qualtrics-store';

export interface QualtricsProps {
  analytics?: AnalyticsStore;
  qualtrics?: QualtricsStore;
}

const QualtricsComponent = ({ analytics, qualtrics }: QualtricsProps) => {
  const { pageName } = analytics && analytics.omnitureData;

  React.useEffect(() => {
    // eslint-disable-next-line @typescript-eslint/no-require-imports
    require('components/common/header/qualtrics-snippet').qualtricsInsert(qualtrics.zoneId);
  }, []);

  /**
   * Qualtrics can access the pageName by using the javascript expression:
   * `document.querySelector('.qualtrics-container').dataset.pageName`
   */

  return <div data-page-name={pageName} className="is-visually-hidden qualtrics-container" />;
};

export const Qualtrics = inject('analytics', 'qualtrics')(QualtricsComponent) as React.ComponentType<QualtricsProps>;
